export default {"src":"/_next/static/media/0xc944E90C64B2c07662A292be6244BDf05Cda44a7.8781c0ba.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};